import { render, staticRenderFns } from "./AddToHomeScreen.vue?vue&type=template&id=6b4e0ba2&scoped=true"
import script from "./AddToHomeScreen.vue?vue&type=script&lang=js"
export * from "./AddToHomeScreen.vue?vue&type=script&lang=js"
import style0 from "./AddToHomeScreen.vue?vue&type=style&index=0&id=6b4e0ba2&prod&lang=css"
import style1 from "./AddToHomeScreen.vue?vue&type=style&index=1&id=6b4e0ba2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4e0ba2",
  null
  
)

export default component.exports